import React from 'react'

import injectStyles from 'react-jss'
import styles from './styles'

const ChatImagePreview = ({ fileURL, classes }) => {
  return (
    <a href={fileURL} target="_blank" className={classes.wrapper}>
      <img className={classes.image} src={fileURL} alt="" />
    </a>
  )
}

export default injectStyles(styles)(ChatImagePreview)



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatMessage/contents/ChatImagePreview/ChatImagePreview.js